export enum SelectParentType {
  REGISTER = 'register',
  WITHDRAWAL = 'withdrawal',
  INVITE = 'invite',
}
